import { Redirect, Route, Switch } from "react-router-dom";
import { Suspense, lazy, } from "react";

import Loading from "components/shared-components/Loading";

const RouteAuth = ({ path, component: Component, ...rest }) => {


  return <Route {...rest} path={path} component={Component} />

};



export const PublicViews = () => {

  const groups = [
    {
      group: 'Invoices',
      description: 'Pagina pública de visualização da fatura',
      routes: [
        {
          description: 'Página Inicial',
          path: "/public/invoices/:id/checkout",
          component: lazy(() => import("./pages/Invoices/index")),
        },
      ],
    },
  ]

  const allRoutes = groups.flatMap((group) => group.routes);


  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        {allRoutes.map(({ component, path }, index) => <RouteAuth key={index} path={path} component={component} />)}
        <Redirect to={'/404'} />
      </Switch>
    </Suspense>
  );
};
